import turfDistance from "@turf/distance";
import { point as turfPoint } from "@turf/helpers";
import { useEffect, useMemo, useState } from "react";

import { getPreciseLocation, parsePointCoords } from "@/utils/geo/geo";

interface UsePointDistanceArgs {
    pointGeo: string | null;
}

const formatDistance = (meters: number): string => {
    const m = Math.round(meters);

    if (m < 1000) {
        return `${m} м`;
    }

    const km = Math.floor(m / 1000);
    const restMeters = m % 1000;

    return restMeters === 0 ? `${km} км` : `${km} км ${restMeters} м`;
};

export const usePointDistance = ({ pointGeo }: UsePointDistanceArgs) => {
    const pointCoords = useMemo(() => parsePointCoords(pointGeo), [pointGeo]);

    const [loading, setLoading] = useState(false);
    const [distance, setDistance] = useState("Відстань до ТТ не визначена");

    useEffect(() => {
        const getCoords = async () => {
            if (!pointCoords) {
                return;
            }

            try {
                setLoading(true);

                const coords = await getPreciseLocation();

                if (pointCoords) {
                    const myPoint = turfPoint([coords.lng, coords.lat]);
                    const pointPoint = turfPoint(pointCoords);

                    const dist = turfDistance(myPoint, pointPoint, {
                        units: "meters",
                    });

                    const distRounded = Math.round(dist);

                    setDistance(
                        `Відстань до ТТ ${formatDistance(distRounded)}`,
                    );
                }
            } catch (error) {
                return;
            } finally {
                setLoading(false);
            }
        };

        getCoords();
    }, [pointCoords]);

    return { distance, loading };
};
